export const UNION = 0;
export const INTERSECT = 1;
export const SUBTRACT = 2;
